module.exports = __webpack_public_path__ + "static/media/iconSetting.e058ca9c.svg";